import SeoCopySection from './SeoCopySection';

export default SeoCopySection;
